import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {TaskType} from "../models/task";
import {useTaskTypes} from "../composables/task";
import {MaybeComputedRef} from "@vueuse/core";
import {useRoute} from "vue-router";

export const useTaskTypesStore = defineStore('taskTypes', () => {
    const taskTypes = ref<TaskType[]>([])
    const loading = ref(false)
    const route = useRoute()

    const projectId = computed(() => Number(route.params.projectId))

    async function select(id: MaybeComputedRef<number>  = projectId) {
        loading.value = true
        const {data} = await useTaskTypes(id)
        taskTypes.value = data.value ?? []
        loading.value = false
    }

    return {taskTypes, select, loading}
})
